<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [canGoBack]="true"
      [title]="'Notifications'"
      [customBack]="backPage || 'more'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">

    @if (errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }

    @if (loaded) {
      <tidy-row [align]="'center'">
        <tidy-text
          [body]="'These notifications trigger for your chosen events.'" /><span>&nbsp;</span>
          <tidy-text
            [actionBody]="'Learn More'"
            class="link"
            (action)="goToLearnMoreNotifications()" />
        </tidy-row>
        @if (notificationSettings[0]?.notifications.length == 0) {
          <tidy-alert>
            <tidy-row>
              <tidy-text
                [body]="'No notifications added.'" />
            </tidy-row>
          </tidy-alert>
        }
        <tidy-button
          [text]="'Add Notifications'"
          [action]="boundGoToAddNotificationPage"
          class="primary" />
        @for (team of notificationSettings; track team) {
          <ng-container class="vertical-align-middle">
            @if (notificationSettings?.length > 1 && team?.notifications?.length) {
              <tidy-row>
                <tidy-text
                  [title]="team?.title" />
              </tidy-row>
            }
            @for (notification of team?.notifications; track notification) {
              <tidy-card>
                <tidy-row class="vertical-align-center">
                  <tidy-image
                    [src]="'assets/img/alert.svg'"
                    class="header-size" />
                  <tidy-text
                    [header]="(notification.display_name | translate) | titlecase" />
                </tidy-row>
                @for (channel of notification.channels; track channel) {
                  <tidy-row [alignLastItemRight]="true">
                    <tidy-text
                      class="link"
                      [actionBody]="channel?.name?.substring(0,37) + (channel?.name?.length > 37 ? '...' : '')"
                      (action)="goToWebhook(channel)" />
                    <tidy-text
                      class="link"
                      [actionBody]="'X'"
                      style="margin-left:5px"
                      (action)="removeEvent(notification, channel)" />
                  </tidy-row>
                }
              </tidy-card>
            }
          </ng-container>
        }
        @if (notificationSettings?.length == 0) {
          <tidy-row class="extra-top-padding" [align]="'center'">
            <tidy-text
              [header]="'How Account Notifications Work:'" />
          </tidy-row>
          @for (card of salesCards; track card) {
            <tidy-alert style="padding: 15px 15px 15px 10px">
              <tidy-grid>
                <tidy-row>
                  <ion-row>
                    <ion-col size="2" class="vertical-align-center">
                      <div style="margin: auto">
                        <tidy-image
                          [src]="card?.image"
                          style="width:35px" />
                      </div>
                    </ion-col>
                    <ion-col>
                      <tidy-row>
                        <tidy-text
                          [header]="card?.title" />
                      </tidy-row>
                      <tidy-row>
                        <tidy-text
                          [body]="card?.text" />
                      </tidy-row>
                    </ion-col>
                  </ion-row>
                </tidy-row>
              </tidy-grid>
            </tidy-alert>
          }
        }
      }
    </tidy-wrapper>
  </ng-template>

  @if (!isRightSideContent) {
    <app-scroll-wrapper [templateContent]="content" />
  }

  @if (isRightSideContent) {
    <ion-content class="ion-content-right-column">
      <ng-container *ngTemplateOutlet="content" />
    </ion-content>
  }
